var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SegmentEvent, CDNDefaultSettings } from '../Utils/Constants';
import P2PLoader from './P2PLoader';
import CDNLoader from './CDNLoader';
import SegmentStorage from '../Storage/SegmentStorage';
import VideoSegment from '../Storage/VideoSegment';
import p2pManager from 'p2p-manager-js';
import Utils from '../Utils/Utils';
import Resource from '../Resource/Resource';
import BalancerApiBusinessObject from '../BusinessObjects/BalancerApiBusinessObject';
import BandwithLimiterBusinessObject from '../BusinessObjects/BandwidthLimiterBusinessObject';
import TestProfilesBusinessObject from '../BusinessObjects/TestProfilesBusinessObject';
/**
 * @class
 * @description Request load main class, it manages and chooses between CDN and P2P requests and evaluates the requests.
 * @exports Loader
 */
export default class Loader {
    /**
     * Constructs loader.
     * @param {Options} options Options object.
     */
    constructor(options) {
        this._segments = new Map();
        this.segmentsMap = new Map(); // NEW segment vs old segment
        this._options = options;
        this._resource = new Resource();
        this.storage = new SegmentStorage(this);
        this.CDNLoader = new CDNLoader(options, this._resource);
        this.P2PLoader = new P2PLoader(options, this.storage);
        TestProfilesBusinessObject.getInstance(this.CDNLoader);
        // Get Data from Balancer API and initialize CDN AND P2P Loaders 
        let balancerApiBusinessObject = new BalancerApiBusinessObject(this);
        this._balancerBusinessObject = balancerApiBusinessObject;
        // this.loadCDNBalancerData();
        // this._exposeData();
    }
    loadCDNBalancerData() {
        if (this._options.resource != undefined && this._options.resource != '') {
            this._balancerBusinessObject.loadBalancerData(this._options.accountCode, this._options.resource, this._options.isLive, this._options.updateTime, this._options.applicationCode, this._options.originCode);
        }
    }
    /**
     * Chooses to request to CDN or P2P and manages the response calling the callback.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer False by default, set as true if is expected to get the manifest response
     * in ArrayBuffer format.
     * @public
     */
    processSegment(url, download, callbacks, headers, retries = CDNDefaultSettings.retries, forceArrayBuffer = false, stats) {
        const header = (headers === null || headers === void 0 ? void 0 : headers.Range) || '';
        const isMedia = Utils.isMedia(url.pathname);
        const isManifest = isMedia ? false : Utils.isManifest(url.pathname);
        const useP2P = false; // this.P2PLoader.enabled && isMedia && Math.random() < this._balancerBusinessObject.p2pProbability;
        const newSegment = new VideoSegment(p2pManager.Util.hash(url.pathname + header), url.href, this._resource, headers, retries, useP2P, forceArrayBuffer);
        newSegment.download = download;
        this._segments.set(url.toString(), newSegment);
        // If is not manifest assing rendition to the current segment to have more data.
        if (!isManifest) {
            let rendition = this._resource.getRendition(url.pathname);
            if (rendition != undefined) {
                newSegment.duration = rendition.targetDuration;
                newSegment.rendition = rendition;
                if (!rendition.isAudio) {
                    this.CDNLoader.currentRenditionBandwidth = rendition.bandwidth;
                    this.CDNLoader.currentRenditionPos = rendition.bandwidthPosition + 1;
                    this.CDNLoader.renditionCount = this._resource.getVideoRenditions().size;
                }
            }
        }
        newSegment.isManifest = isManifest;
        newSegment.isMedia = isMedia;
        // Doesn't declare it if we doesn't donload teh content
        if (download) {
            newSegment.on(SegmentEvent.Success, (e) => __awaiter(this, void 0, void 0, function* () {
                this.onProcessSegmentSuccess(newSegment);
                callbacks[0](newSegment);
            }));
            newSegment.on(SegmentEvent.Fail, (e) => {
                this.onProcessSegmentFail(newSegment, true);
                if (newSegment.retries == 0)
                    if (callbacks.length > 1) {
                        callbacks[1]();
                    }
                console.error(`Segment request failed, no more retries ${newSegment.route}`);
            });
        }
        // If p2p, tries to use load via p2p, if not, cdn
        if ((!newSegment.useP2P || !this.P2PLoader.request(newSegment))) {
            newSegment.requestToCdn(this.CDNLoader.getSecure());
            //if( !newSegment.isManifest ){
            this.CDNLoader.updateUrl(newSegment);
            //}
        }
        this.CDNLoader.getActiveRequests().set(newSegment.id, newSegment);
        newSegment.startTime = Date.now();
        return newSegment;
    }
    onProcessSegmentFail(segment, retry) {
        const cdnName = segment.cdnName;
        // Update CDN Loader stats 
        this.CDNLoader.updateCDNStatsOnFailure(cdnName, segment);
        if (segment.triedP2P && segment.useP2P == true) {
            segment.useP2P = false;
            this.CDNLoader.updateUrl(segment);
            segment.requestToCdn(this.CDNLoader.getSecure());
        }
        if (retry && segment.retries > 0) {
            this.CDNLoader.updateUrl(segment);
            segment.requestToCdn(this.CDNLoader.getSecure());
        }
        else {
            this.CDNLoader.removeActiveSegment(segment);
            // Delete segment from map
            this._segments.delete(segment.url);
        }
        //  this._exposeData();
    }
    onProcessSegmentSuccess(segment) {
        let testProfiles = TestProfilesBusinessObject.getInstance();
        testProfiles.push(segment);
        segment.off(SegmentEvent.Success);
        segment.off(SegmentEvent.Fail);
        let maxBandwith = this.CDNLoader.getMaxBandwidth(segment.cdnName);
        if (maxBandwith > 0) {
            let limiter = new BandwithLimiterBusinessObject();
            limiter.limit(maxBandwith, segment);
        }
        // Update CDN Loader stats
        this.CDNLoader.updateCDNStatsOnSuccess(segment);
        // Update active segments
        this.CDNLoader.removeActiveSegment(segment);
        // Store the media
        if (this.P2PLoader.enabled && segment.isMedia) {
            this.P2PLoader.storeNewSegment(segment, segment.data);
        }
        // Delete segment from map
        this._segments.delete(segment.url);
        //  this._exposeData();
    }
    /**
     * Returns the map of unfinished/active CDN requests.
     * @returns {Map<string,VideoSegment>} The map with the requests.
     * @public
     */
    /*public getActiveCdnDownloads(): Map<string, VideoSegment> {
      return this.CDNLoader.getActiveRequests();
    }*/
    enableCDN(name, enabled) {
        if (name === 'P2P') {
            if (this.P2PLoader.enabled !== enabled) {
                this.P2PLoader.enabled = enabled;
                return true;
            }
            return false;
        }
        return this.CDNLoader.enableCDN(name, enabled) || false;
    }
    setMaxBandwith(name, bandwidth) {
        if (name === 'P2P') {
            return false;
        }
        return this.CDNLoader.setMaxBandwidth(name, bandwidth) || false;
    }
    /**
    * Exposes the updated stats of this plugin in an object placed in the window.
    * @private
    */
    /*private _exposeData() {
      if (typeof window !== 'undefined') {
        window['CdnBalancerStats'] = this.CDNLoader.getStats();
      }
    }*/
    loadEM(xhr, url, e) {
    }
    ;
    loadStartEM(xhr, url, e) {
    }
    ;
    progressEM(xhr, url, e) {
        let segment = this._segments.get(url.toString());
        if (segment != undefined) {
            segment.onProgress(e);
            this.CDNLoader.updateProgressStats();
            //  this._exposeData();
        }
    }
    ;
    getSegment(url) {
        let segment = this._segments.get(url);
        return segment;
    }
    getSegmentOriginalUrl(url) {
        let oldName = this.segmentsMap.get(url);
        return oldName;
    }
    readyStateChangeEM(xhr, url) {
        const response = xhr.response;
        // console.log("k2"); 
        let segment = this._segments.get(url.toString());
        switch (xhr.readyState) {
            case 4: //Done
                if (segment != undefined) {
                    if (xhr.status >= 400 || xhr.status < 200) {
                        this.onProcessSegmentFail(segment, false);
                        return false;
                    }
                    else {
                        let ok = segment.onSuccess(xhr.response);
                        if (ok) {
                            this.onProcessSegmentSuccess(segment);
                        }
                        else {
                            this.onProcessSegmentFail(segment, false);
                        }
                        return true;
                    }
                }
                else {
                    //("[NPAW] -> Undefined segment");
                }
                break;
        }
        return true;
    }
    ;
    loadEndEM(xhr, url, e) {
    }
    ;
    errorEM(xhr, url, e) {
    }
    ;
}
